import script from "./SMSTemplateDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./SMSTemplateDetails.vue?vue&type=script&lang=ts&setup=true"

import "./SMSTemplateDetails.vue?vue&type=style&index=0&id=56674b15&lang=scss"

const __exports__ = script;

export default __exports__